import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { EduQuiz } from 'components';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';
import * as eduActions from 'modules/edu';
import * as currentStatusActions from 'modules/currentStatus';
import { reduxForm, reset, touch, focus, isValid } from 'redux-form';

class CtEduQuizConf extends Component {
  constructor(props) {
    super(props);

    // 검색 기록 유지
    // const { paramData } = this.props;
    // const filterData = paramData.get('filter').toJS();
    // let searchTypeData = 'searchAll';
    // let searchTextData = '';
    // if (Object.keys(filterData).length) {
    //   const searchOptions = [
    //     'searchAll',
    //     'serviceNo',
    //     'serviceName',
    //     'attachSubject',
    //     'templateName',
    //     'senderName',
    //     'senderEmail',
    //     'subject'
    //   ];
    //   searchOptions.map(option => {
    //     if (filterData[option]) {
    //       searchTypeData = option;
    //       searchTextData = filterData[option];
    //     }
    //   });
    // }

    this.state = {
      loading: false,
      currentPage: 0,
      pageSize: 0,
      fitRowCount: 0,
      // 검색
      searchType: 'searchAll',
      searchValue: '',
      tempFilter: {},
      quizRowInfo: {}
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    // this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidMount() {
    this.getEduQuiz();
  }

  componentDidUpdate(prevProps, prevState) {
    const { needReload, paramData, eduQuizManage, formStore } = this.props;
    const { currentPage, pageSize } = this.state;

    if (
      needReload !== prevProps.needReload ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData ||
      // 페이지 이동 클릭 시
      currentPage !== prevState.currentPage ||
      // 한 페이지에 표시할 개수 변경 시
      pageSize !== prevState.pageSize ||
      // 퀴즈 등록, 삭제 시
      eduQuizManage !== prevProps.eduQuizManage
    ) {
      this.getEduQuiz();
    }
  }

  onToggleModal = viewType => {
    // const { ReduxFormReset } = this.props;
    // ReduxFormReset(viewType);

    if (!!viewType) {
      this.getEduAttach();
    }

    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  getEduAttach = async () => {
    const { EduActions } = this.props;
    await EduActions.getEduAttach();
  };

  getQuizInfo = quizInfo => {
    this.setState({
      quizRowInfo: quizInfo
    });
  };

  // 퀴즈 리스트 조회
  getEduQuiz = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { EduActions, paramData } = this.props;
        // currentPage: 현재 보고있는 페이지, pageSize: 한 페이지에 출력할 리스트 개수( 오른쪽 상단 드롭다운에서 고르는 값으로 변경됨 )
        const { currentPage, pageSize, searchType, searchValue } = this.state;

        const params = {
          // filter: paramData.get('filter'),
          filter: searchValue ? { [searchType]: searchValue } : {},
          sort: JSON.stringify(paramData.get('sort')),
          // offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          // limit: pageSize < 1 ? 20 : pageSize
          offset: pageSize * currentPage,
          limit: pageSize
        };

        await EduActions.getEduQuiz(params);
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  // 퀴즈 우측 상단 '등록' 버튼 클릭 이벤트
  handleOnPost = () => {
    // this.getEduAttach();
    const { onToggleModal } = this;
    onToggleModal('eduQuizAdd');
  };

  // 검색 입력값 받아오기
  takeSearchValue = value => {
    // SEARCH_VALUE = searchValue;
    // console.log('searchValue', value);
    this.setState({
      searchValue: value
    });
  };

  // 페이지 이동 영역 클릭 이벤트
  handlePagination = page => {
    this.setState({
      currentPage: page
    });
  };

  // 페이지 개수 설정 이벤트
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색 이벤트
  handleOnSearch = e => {
    const { searchValue, searchType } = this.state;
    const { EduActions } = this.props;

    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      const filter = {};
      if (!!searchValue) {
        filter[searchType] = searchValue;
      }

      this.setState({ currentPage: 0 });
      EduActions.changeEduQuizParam({
        name: 'filter',
        value: filter
      });
    }
  };

  // 필터 항목(체크박스 영역)별 클릭 이벤트
  checkFilter = (filterName, data) => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter[filterName] === 'undefined') {
      filter[filterName] = [data.value];
    } else {
      const indexArray = filter[filterName].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter[filterName].push(data.value);
      } else {
        filter[filterName].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter[filterName].length === 0 && delete filter[filterName];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 확인 버튼 클릭 이벤트
  executeFilter = () => {
    const { EduActions } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    EduActions.changeEduQuizParam({
      name: 'filter',
      value: filter
    });
  };

  // 취소 버튼 클릭 이벤트
  cancelFilter = () => {
    const { paramData } = this.props;
    const filter = paramData.get('filter');

    this.setState({
      tempFilter: filter
    });
  };

  // 모든 필터 해제 버튼 클릭 이벤트
  resetFilter = () => {
    const { EduActions } = this.props;
    EduActions.changeEduQuizParam({
      name: 'filter',
      value: {}
    });

    // if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
    //   this.myTextInput.inputRef.value = '';
    // }

    this.setState({
      searchType: 'searchAll',
      // searchText: '',
      tempFilter: {}
    });
  };

  //필터 팝업 닫힐 때
  filterClose = () => {
    const { paramData } = this.props;
    const filter = paramData.get('filter');

    this.setState({
      tempFilter: filter,
      // isLoading: false
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { eduQuizManage, totalQuizCount, totalQuizPages, paramData, formStore, isModal, eduAttachByAttachNo } = this.props;
    const { loading, currentPage, pageSize, fitRowCount, searchType, tempFilter, quizRowInfo } = this.state;
    const {
      takeSearchValue,
      handlePagination,
      handlePageSizeOnChange,
      handleOnSearch,
      handleSearchOptions,
      checkFilter,
      executeFilter,
      cancelFilter,
      resetFilter,
      filterClose,
      onToggleModal,
      handleOnPost,
      getQuizInfo
    } = this;

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = pageSizeArray.map(value => {
      return { text: value, value: value };
    });

    const searchOptions = [
      {
        key: 0,
        text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })),
        value: 'searchAll'
      },
      {
        key: 1,
        text: defineMessages(formatMessage({ id: 'Quiz_2', defaultMessage: '퀴즈 내용' })),
        value: 'quizContent'
      },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: 'Quiz_8', defaultMessage: '교육 영상' })),
        value: 'fileName'
      }
    ];

    return (
      <EduQuiz
        quizData={eduQuizManage}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalQuizPages}
        handlePagination={handlePagination}
        // 검색
        searchObj={{
          filterData: paramData.filter,
          currentPage,
          pageSize,
          totalCount: totalQuizCount,
          searchType,
          // searchText,
          searchOptions,
          handleSearchOptions,
          // handleChangeSearch,
          handleOnSearch,
          // handleInitFilter,
          defaultPageSize: fitRowCount,
          pageSizeOptions,
          handlePageSizeOnChange,
          takeSearchValue,
          // searchTextRef,
          paramData,
          tempFilter
        }}
        // 필터
        checkFilter={checkFilter}
        executeFilter={executeFilter}
        cancelFilter={cancelFilter}
        resetFilter={resetFilter}
        // 필터 팝업창 닫힐 때 이벤트
        filterClose={filterClose}
        onToggleModal={onToggleModal}
        handleOnPost={handleOnPost}
        formStore={formStore}
        isModal={isModal}
        eduAttachByAttachNo={eduAttachByAttachNo}
        getQuizInfo={getQuizInfo}
        quizRowInfo={quizRowInfo}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    eduQuizManage: state.edu.get('eduQuizManage'),
    totalQuizCount: state.edu.get('totalQuizCount'),
    totalQuizPages: state.edu.get('totalQuizPages'),
    paramData: state.edu.get('quizParam'),
    eduAttachByAttachNo: state.edu.get('eduAttachByAttachNo'),
    formStore: state.form['eduQuizAddEdit'],
    isModal: state.currentStatus.get('isModal')
  };
};

const mapDispatchToProps = dispatch => ({
  EduActions: bindActionCreators(eduActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtEduQuizConf));


// WEBPACK FOOTER //
// ./src/script/containers/config/CtEduQuizConf.js